import axios from "axios";

// Utility to get cookie from document.cookie
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    for (let cookie of cookies) {
      if (cookie.startsWith(name + "=")) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Create Axios instance with CSRF + session support
const API = axios.create({
  baseURL: "https://api.instilit.com",
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

// Interceptor to add Authorization and CSRF tokens to every request
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    const csrfToken = getCookie("csrftoken");
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

//  Helper:
export const ensureCsrfToken = async () => {
  try {
    await API.get("/api/userreviews");
    console.log("CSRF cookie initialized");
  } catch (error) {
    console.warn(" CSRF init failed", error);
  }
};


export const fetchCourses = () => API.get("/courses");
export const fetchFutureTechVideos = () => API.get("/futuretech-training");
export const fetchTrainers = () => API.get("/trainers");
export const fetchTestimonials = () => API.get("/api/userreviews");
export const postTestimonial = (testimonialData) => API.post("/userreviews", testimonialData);
export const saveTrainer = (trainerData) => API.post("/trainers", trainerData);
export const getMockInterviews = () => API.get("/api/mock-interview/");
export const bookMockInterview = (interviewData) => API.post("/mock-interview/", interviewData);
export const postContact = (formData) => API.post("/contacts/", formData);

// Example direct call using instance
export const getCourseDetails = async () => {
  try {
    const response = await API.get("/api/courses/details");
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
};
